import service from '@/services/SICUDgpd_resul_eval';

export default {
  namespaced: true,

  actions: {
    /**
     * Petición para obtener labels registrados en Integrity que serán utilizados en una vista.
     */
    async update({ dispatch, rootGetters }, values) {
      return new Promise((resolve, reject) => {
        const payload = {
          dsSICUDgpd_resul_est: {
            eeDatos: [rootGetters['auth/state']],
            eegpd_resul_est: [
              {
                doc_num: rootGetters['SICUDgpd_est_crd/state'].numberDocument || 0, // default,
                ter_nit: rootGetters['SICUDgpd_est_crd/state'].nit,
                crd_val: values.step1.monthlyIncomeWasPreFilled
                  ? Number(values.step1.monthlyIncome || '0')
                  : 0,
                crd_ing_men: !values.step1.monthlyIncomeWasPreFilled
                  ? Number(values.step1.monthlyIncome || '0')
                  : 0,
                crd_mes: values.step1.timeInCompany,
                crd_tip_cont: values.step1.contractType[0]?.tip_cod || values.step1.contractType,
                crd_cont: values.step1.clientProfile[0]?.act_cod || values.step1.clientProfile,
                crd_otr_ing: values.step1.otherIncome,
                crd_ano_cam: values.step1.crd_ano_cam,
                crd_ocu_det: values.step1?.crd_ocu_det?.[0]?.lis_det_par
                  || values.step1.cdr_ocu_det,
              },
            ],
          },
        };

        let notification;

        service
          .update(payload)
          .then((response) => {
            const data = response.data.dsSICUDgpd_resul_est;

            if (data.eeEstados[0].Returnid === 0) {
              resolve(data.eegpd_resul_est[0]);
            } else if (data.eeEstados[0].Returnid === 98) {
              resolve([]);
            } else {
              notification = {
                code: data.eeEstados[0].Returnid,
                message: data.eeEstados[0].Estado,
                timestamp: Date.now(),
                type: 'error',
              };

              throw notification;
            }
          })
          .catch((error) => {
            if (error.type === undefined) {
              notification = {
                code: undefined,
                message: error.message,
                timestamp: Date.now(),
                type: 'error',
              };
            }

            dispatch('notification/create', notification, {
              root: true,
            });

            reject(notification);
          });
      });
    },
  },
};
